exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".botones-edicion {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-align: end;\r\n      align-items: flex-end;\r\n}\r\n\r\n.img-preview {\r\n  height: auto;\r\n  max-height: 150px;\r\n  width: auto;\r\n  max-width: 233px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.empty {\r\n  min-height: 150px;\r\n  border: 1px solid;\r\n}\r\n\r\n.img-preview-container {\r\n  border: 1px dashed #DCDADB;\r\n  height: 152px;\r\n  width: 235px;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-align: center;\r\n      align-items: center;\r\n  -ms-flex-pack: center;\r\n      justify-content: center;\r\n  background-color: #FFFFFF;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .img-preview-container {\r\n    width: 190px;\r\n  }\r\n\r\n  .img-preview {\r\n    max-width: 188px;\r\n  }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/fileUpload/imageUploader.component.css
// module id = ../../../../../src/app/helpers/components/fileUpload/imageUploader.component.css
// module chunks = main